import React from 'react';
import { formatDate } from '../utils';

const BasicInformationSection = ({ ticket }) => {
  return (
    <div className="mb-6 p-6 rounded-xl border border-blue-500/10 shadow-lg relative bg-gradient-to-br from-slate-50 to-slate-100 before:content-[''] before:absolute before:top-0 before:left-0 before:w-1 before:h-full before:bg-gradient-to-b before:from-blue-600 before:to-blue-500 before:rounded-l-sm">
      <h3 className="text-slate-900 font-bold mb-4 font-poppins flex items-center gap-3 text-xl">
        📝 Basic Information
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {/* Only show name field if not Account Management */}
        {ticket.category !== 'ACCOUNT_MANAGEMENT' && (
          <div className="col-span-1">
            <div className="p-4 bg-white rounded-lg border border-blue-500/8 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200">
              <p className="font-poppins font-semibold text-xs uppercase tracking-wider mb-2 text-slate-600">
                👤 Name
              </p>
              <p className="font-semibold font-poppins text-slate-900 text-base">
                {ticket.name}
              </p>
            </div>
          </div>
        )}
        
        <div className="col-span-1">
          <div className="p-4 bg-white rounded-lg border border-blue-500/8 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200">
            <p className="font-poppins font-semibold text-xs uppercase tracking-wider mb-2 text-slate-600">
              ✉️ Email
            </p>
            <p className="font-semibold font-poppins text-slate-900 text-base break-words">
              {ticket.email}
            </p>
          </div>
        </div>
        
        <div className="col-span-1">
          <div className="p-4 bg-white rounded-lg border border-blue-500/8 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200">
            <p className="font-poppins font-semibold text-xs uppercase tracking-wider mb-2 text-slate-600">
              📅 Created
            </p>
            <p className="font-semibold font-poppins text-slate-900 text-base">
              {formatDate(ticket.createdAt)}
            </p>
          </div>
        </div>
        
        {ticket.location && (
          <div className="col-span-1">
            <div className="p-4 bg-white rounded-lg border border-blue-500/8 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200">
              <p className="font-poppins font-semibold text-xs uppercase tracking-wider mb-2 text-slate-600">
                📍 Location
              </p>
              <p className="font-semibold font-poppins text-slate-900 text-base">
                {ticket.location.type === 'SCHOOL' ? '🏫 School - ' : '🏢 SDO - '}
                {ticket.location.type === 'SCHOOL' ? ticket.location.name : 'Imus City'}
                {ticket.location.type === 'SCHOOL' && ticket.location.level && (
                  <span className="block font-poppins mt-1 text-slate-600 text-sm">
                    School Level: {ticket.location.level}
                  </span>
                )}
                {ticket.location.type === 'SDO' && (
                  <span className="block font-poppins mt-1 text-slate-600 text-sm">
                    Department: {ticket.department || 'Information and Communications Technology Unit'}
                  </span>
                )}
              </p>
            </div>
          </div>
        )}
        
        {/* Category-specific type information */}
        {ticket.category === 'DOCUMENT_UPLOAD' && ticket.documentType && (
          <div className="col-span-1">
            <div className="p-4 bg-white rounded-lg border border-blue-500/8 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200">
              <p className="font-poppins font-semibold text-xs uppercase tracking-wider mb-2 text-slate-600">
                📄 Document Type
              </p>
              <p className="font-semibold font-poppins text-slate-900 text-base">
                {ticket.documentType.name || 'Not specified'}
              </p>
            </div>
          </div>
        )}
        
        {ticket.category === 'ACCOUNT_MANAGEMENT' && ticket.accountType && (
          <div className="col-span-1">
            <div className="p-4 bg-white rounded-lg border border-blue-500/8 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200">
              <p className="font-poppins font-semibold text-xs uppercase tracking-wider mb-2 text-slate-600">
                👥 Account Type
              </p>
              <p className="font-semibold font-poppins text-slate-900 text-base">
                {ticket.accountType.name || 'Not specified'}
              </p>
            </div>
          </div>
        )}
        
        {ticket.category === 'TECHNICAL_ASSISTANCE' && ticket.taType && (
          <div className="col-span-1">
            <div className="p-4 bg-white rounded-lg border border-blue-500/8 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200">
              <p className="font-poppins font-semibold text-xs uppercase tracking-wider mb-2 text-slate-600">
                🛠️ Technical Assistance Type
              </p>
              <p className="font-semibold font-poppins text-slate-900 text-base">
                {ticket.taType.name || 'Not specified'}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BasicInformationSection;